<template>
    <SectionComponent :id="'siro'" :class="'siro'">
        <div class="row g-4">
            <!-- Left Box -->
            
            <div class="col-md-6">
            <div class="card h-100 shadow-sm position-relative overflow-hidden">
                <!-- Image Container with Hover Effect -->
                <div class="image-container">
                <img
                    src="/assets/images/siro/pagoonline.png"
                    class="card-img-top"
                    alt="Pago Online"
                />
                <div class="image-overlay"></div>

                <!-- Ribbon -->
                <div class="ribbon-wrapper">
                    <div class="ribbon">TENEMOS...</div>
                </div>
                </div>

                <!-- Centered Body -->
                <div class="card-body d-flex flex-column justify-content-center text-center flex-grow-1 siro-body">
                <h4 class="fw-bold text-dark mb-3">
                    ¿Sabía que puede abonar desde su Celular o Pc?
                </h4>
                <p class="text-muted mb-4">
                    Lea el Paso a Paso, y haga click en el botón debajo
                </p>
                <a href="https://siropagos.bancoroela.com.ar/" target="_blank" class="btn btn-success w-auto mx-auto px-4 py-2 fw-semibold">Pague Aquí</a>
                </div>
            </div>
            </div>
            <!-- Right Box -->
            <div class="col-md-6">
            <a href="/assets/siro/paso_a_paso_pago_siro.pdf" target="_blank">
                <img src="/assets/images/siro/pasossiro.png" alt="SIRO" class="img-fluid w-100">
            </a>
            </div>
        </div>
    </SectionComponent>
</template>

<script>
import SectionComponent from './SectionComponent.vue'

export default {
  components: {
    SectionComponent
  }
}
</script>

<style scoped>

.ribbon-wrapper {
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

.ribbon {
  position: absolute;
  display: block;
  width: 200px;
  text-align: center;
  background-color: #2f4f2f;
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 4px 0;
  transform: rotate(-45deg);
  top: 25px;
  left: -45px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.siro-body {
 background-color: #f7f7f7;
}

/* Hover Zoom + Dark Overlay */
.image-container {
  position: relative;
  overflow: hidden;
  height: 250px;
}

.image-container img {
  transition: transform 0.4s ease;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  transition: background-color 0.4s ease;
  z-index: 1;
}

.image-container:hover img {
  transform: scale(1.05);
}

.image-container:hover .image-overlay {
  background-color: rgba(0, 0, 0, 0.3);
}
</style>